import { useContext } from "react"

import { DragTypeContext } from "@/context/DragTypeContext"

export const useDragType = () => {
  return useContext(DragTypeContext)
}

export default useDragType
